<template>
  <div id="add_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            v-if="formParam.header.id != '' && formParam.header.id != null"
          >
            Edit Text Reply
          </h5>
          <h5 class="modal-title" v-else>Add Text Reply</h5>
          <!-- {{broadcastParam.broadcast_id}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="tab-content">
            <!-- {{ formParam.header }} -->
            <div
              :class="
                tabMessage == 'setup' ? 'tab-pane show active' : 'tab-pane'
              "
              id="form"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="row">
                            <div class="col-sm-8 col-md-8">
                              <div class="form-group">
                                <label>
                                  License:
                                  <span class="text-danger">*</span>
                                </label>
                                <licenseSelect v-model="selectedContact" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="submit-section">
            <div class="row"> 
              <div class="col-md-12">
                <div class="form-group">
                  <center>
                    <!-- {{isSending}} -->
                    <button
                      @click="saveForm(0, 1)"
                      class="btn btn-md btn-warning"
                      type="button"
                    >
                      <i class="fa fa-save"></i> Draft
                    </button>

                    <button
                      @click.prevent="saveForm(0, 0)"
                      class="btn btn-md btn-success"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-check"></i> Publish
                    </button>
                  </center>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <center>
                    <button
                      @click.prevent="saveForm(1, 0)"
                      class="btn btn-lg btn-info"
                      type="button"
                    >
                      <i class="fa fa-check"></i> Publish &amp; Exit
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import TagsAssign from "./components/tagsAssign.vue";
import TagsAssignNotif from "./components/tagsAssignNotif.vue";

import PreviewMessage from "./preview";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC,
} from "@/utils/helper";
import licenseSelect from "../../license/licenseSelect.vue";
export default {
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    Emoji: VueChatEmoji,
    Multiselect,
    Datetime,
    PreviewMessage,
    TagsAssign,
    licenseSelect,
    TagsAssignNotif,
  },
  props: {
    searchData: {
      type: Function,
    },
  },
  data() {
    return {
      interactiveMessageType: [
        // { id: "button", label: "Button" },
        { id: "link", label: "Link/Call" },
        // { id: "list_text", label: "List" }
      ],
      tabMessage: "setup", //setup or preview
      selectedContact: null,

      formParam: {
        header: {
          id: "",
          title: "",
          message: "",
          is_enable_attach_file: false,
          footer_message: "",
          footer_message_status: false,
          is_custom_url: false,
          image_url: "",
          message_type: "text",
          tag_id: JSON.stringify([]),
          tag_id_notif: JSON.stringify([]), //phone number
          // button_type: "link",
          // button_type_away_message: "link"
        },
      },
      isLoading: false,
    };
  },
  watch: {
    selectedLicense: {
      handler: function (val, oldVal) {
        // console.log("selectedLicense", val, oldVal);
        if (val.length > 1 && val != oldVal) {
          var that = this;
          setTimeout(function () {
            // if (
            //   that.broadcastParam.broadcast_id != "" &&
            //   that.broadcastParam.broadcast_id != null
            // ) {
            let lengthOld = oldVal.length;
            val.splice(0, 1);
            that.selectedLicense = val;
            that.formParam.header.license_id = val[0].id;
            return;
            // }
          }, 300);
        }

        // if (val != oldVal) {
        if (val.length == 1) {
          this.selectedLicense = val;
          this.formParam.header.license_id = val[0].id;
          return;
        }
        if (val != oldVal && oldVal.length == 1 && val.length < 1) {
          this.selectedLicense = [];
          this.formParam.header.license_id = "";
          return;
        }
      },
      deep: true,
    },
    isShowForm: {
      handler: function (val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          this.settabMessage("setup");
          this.selectedLicense = [];
          this.buttonsRows = [];
          this.linkRows = [];
          var that = this;
          setTimeout(function () {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.formParamTRSt.header.id != "" &&
              that.formParamTRSt.header.id != null
            ) {
              if (
                typeof that.formParamTRSt.header.copy != "undefined" &&
                that.formParamTRSt.header.copy == true
              ) {
                that.formParamTRSt.header.id = "";
              }

              that.formParam = that.formParamTRSt;

              if (that.formParam.header.image_url != "") {
                that.formParam.header.is_enable_attach_file = true;
                that.uploadMessageType = that.formParam.header.message_type;
              } else {
                that.uploadMessageType = "image";
              }

              that.$store.dispatch(
                "automation/setTextReplyTagId",
                that.formParamTRSt.header.tag_id
              );
              that.$store.dispatch(
                "automation/setTextReplyTagIdNotif",
                that.formParamTRSt.header.tag_id_notif
              );

              // that.formParam.header.tag_id = JSON.parse(that.formParamTRSt.header.tag_id);
              // that.formParam.header.tag_id_notif = JSON.parse(that.formParamTRSt.header.tag_id_notif);

              // console.log("that.formParam", that.formParam);
            } else {
              // that.loadReplyButtons();
              // that.loadReplyLink();
              that.formParam = {
                header: {
                  id: "",
                  title: "",
                  message: "",
                  is_enable_attach_file: false,
                  is_custom_url: false,
                  image_url: "",
                  message_type: "text",
                  tag_id: JSON.stringify([]),
                  tag_id_notif: JSON.stringify([]),
                },
              };

              that.$store.dispatch("automation/setTextReplyTagId", "[]");
              that.$store.dispatch("automation/setTextReplyTagIdNotif", "[]");
            }
          }, 100);
        }
      },
      deep: true,
    },
  },
  computed: {
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken(),
        // "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    },
    ...mapGetters(["agentSession"]),
    formParamTRSt() {
      return this.$store.state.automation.formParamTRSt;
    },
    isShowForm() {
      return this.$store.state.automation.isShowForm;
    },
  },
  methods: {
    settabMessage(value) {
      this.tabMessage = value;
    },
    addRow() {
      let newRow = {
        select_variable: "conversation",
        condition: "",
        text: "",
      };
      this.formParam.detail_some.push(newRow);
    },
    removeRow(removeIndex, maxIndex) {
      // console.log("removeIndex", removeIndex, maxIndex);
      if (removeIndex == 0 && maxIndex == 0) {
        return;
      }

      if (removeIndex > -1) {
        // only splice array when item is found
        this.formParam.detail_some.splice(removeIndex, 1); // 2nd parameter means remove one item only
      }
    },
    async loadReplyButtons() {
      this.buttonsLoading = await true;
      this.buttonsParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyButtons", this.buttonsParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.buttonsRows = data.data;
          this.buttonsLoading = false;
        })
        .catch((error) => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    async loadReplyLink() {
      this.buttonsLoading = await true;
      this.linkParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyLink", this.linkParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.linkRows = data.data;
          this.buttonsLoading = false;
        })
        .catch((error) => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    resetDetailButton() {},

    addTemplateToMesage(template) {
      this.formParam.header.message += template;
    },
    addTemplateToMesage2(template) {
      this.formParam.header.message_away += template;
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },
    async savePreview() {
      this.formParam.header.message = await this.remove_tags(
        this.formParam.header.message
      );

      await this.$store.dispatch("automation/actFormParamTRSt", this.formParam);
    },
    updateTag(tagIdArr) {
      // console.log("from Parent: ", tagIdArr)
      let parTagId = [];
      tagIdArr.forEach((row, idx) => {
        parTagId.push(row.id);
      });
      this.formParam.header.tag_id = JSON.stringify(parTagId);
    },
    updateTagNotif(tagIdArr) {
      // console.log("from Parent: ", tagIdArr)
      let parTagId = [];
      tagIdArr.forEach((row, idx) => {
        parTagId.push(row.id);
      });
      this.formParam.header.tag_id_notif = JSON.stringify(parTagId);
    },
    async saveForm(isExit = 0, isDraft = 0) {
      if (this.formParam.header.footer_message_status == false) {
        this.formParam.header.footer_message = ""; //data dihapus
      }

      if (typeof isDraft == "undefined") {
        this.formParam.header.is_publish = 1;
      } else {
        if (isDraft == 1) {
          this.formParam.header.is_publish = 0;
        } else {
          this.formParam.header.is_publish = 1;
        }
      }

      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      }).then(async (r) => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;
          this.emojiToggle(false);
          this.formParam.header.message = await this.remove_tags(
            this.formParam.header.message
          );
          this.formParam.header.network_id = parseInt(
            this.formParam.header.network_id
          );
          this.formParam.header.create_datetime = parseInt(
            this.formParam.header.create_datetime
          );
          this.formParam.header.update_datetime = parseInt(
            this.formParam.header.update_datetime
          );
          await this.$store
            .dispatch("automation/storeTextReply", this.formParam)
            .then((response) => {
              // this.isSending = false;
              if (this.formParam.id == "") {
                this.formParam = {
                  header: {
                    id: "",
                    title: "",
                    message: "",
                    is_enable_attach_file: false,
                    is_custom_url: false,
                    image_url: "",
                  },
                };
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000,
              }).then((r) => {});
              this.searchData({ isExit: isExit, data: response.data });
              if (isExit == 1) {
                var elem = this.$refs.dismisModal;
                elem.click();
              }
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.formParam.header.message += args.emoji;
      // console.log(args); /* return {...}*/
    },

    updateMessageSupportCurrent(msgType) {
      this.uploadMessageSupportSelected = msgType;
    },
    updateMessageTypeCurrent(msgType) {
      if (msgType == "") {
        var that = this;
        setTimeout(function () {
          // console.log(
          //   "that.formParam.header.is_enable_attach_file",
          //   that.formParam.header.is_enable_attach_file
          // );
          if (that.formParam.header.is_enable_attach_file == true) {
            that.formParam.header.message_type = "image";
            that.uploadMessageType = that.formParam.header.message_type;
            // that.formParam.header.is_custom_url = false;
            // console.log("that.uploadMessageTyp",that.uploadMessageType)
          } else {
            that.formParam.header.message_type = "text";
          }
        }, 100);
      } else {
        this.uploadMessageType = msgType;
        this.formParam.header.message_type = msgType;
      }
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.uploadbc.active = true;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512,
          });
          imageCompressor
            .compress(newFile.file)
            .then((file) => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type,
              });
            })
            .catch((err) => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress",
              });
            });
        }
      }
      console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width,
          });
        };
        img.οnerrοr = (e) => {
          console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        console.log("oldddd", oldFile);
        console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            message_type: this.uploadMessageType,
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          // console.log("err", newFile.error.response);
          // console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000,
          }).then((r) => {});
        }
        if (newFile.success && !oldFile.success) {
          this.formParam.header.image_url = newFile.response.data.url;
          this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        this.formParam.header.image_url = "";
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    APICoreV2() {
      return APICoreV2();
    },
    APICore() {
      return APICore();
    },
  },
  async created() {
    this.$root.$on("updateTag", async (tagIdArr) => {
      this.updateTag(tagIdArr);
    });
    this.$root.$on("updateTagNotif", async (tagIdArr) => {
      this.updateTagNotif(tagIdArr);
    });
  },
  beforeDestroy() {
    this.$root.$off("updateTag");
    this.$root.$off("updateTagNotif");
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add",
};
</script>



// WEBPACK FOOTER //
// src/views/ai/workflow/form.vue